import { getType } from 'typesafe-actions'
import { setInitRio } from './actions'
import { InstrumentationState } from './types'

const initialState: InstrumentationState = {
  isRioInit: false,
}
const instrumentationReducer = (state = initialState, action) => {
  switch (action.type) {
    case getType(setInitRio):
      return { ...state, isRioInit: true }
    default:
      return state
  }
}

export default instrumentationReducer
